export const form = (context) => {
    const fd = new FormData()

    for (const key in context) fd.append(key, context[key])

    return fd
}
